import { useMemo } from "react";

export const useInventoryDataProcessing = (props) => {
  let {
    data,
    activeTab,
    search = "",
    sortBy = "newest",
    filters = {}
  } = props || {};

  data = Array.isArray(data) ? data : [];
  const filteredData = useMemo(() => {
    const searchStr = search.toLowerCase();
    //updated Halimunnisa 2026-06-08
    return data.filter(item => {
      // Date Filtering
      if (filters.fromDate || filters.toDate) {
        const itemDate = new Date(item.createdAt || item.createdDate || item.date);
        if (filters.fromDate && itemDate < new Date(filters.fromDate)) return false;
        if (filters.toDate) {
            const toDate = new Date(filters.toDate);
            toDate.setHours(23, 59, 59, 999);
            if (itemDate > toDate) return false;
        }
      }
      // Apply Quick Date Preset (T, W, M, Y)
      if (filters.date && filters.date !== 'all') {
        const itemDate = new Date(item.createdAt || item.createdDate || item.date);
        const today = new Date();
        if (filters.date === 'today') {
            if (itemDate.toDateString() !== today.toDateString()) return false;
        } else if (filters.date === 'this_week') {
            const firstDay = new Date(today.setDate(today.getDate() - today.getDay()));
            if (itemDate < firstDay) return false;
        } else if (filters.date === 'this_month') {
            if (itemDate.getMonth() !== today.getMonth() || itemDate.getFullYear() !== today.getFullYear()) return false;
        } else if (filters.date === 'this_year') {
            if (itemDate.getFullYear() !== today.getFullYear()) return false;
        }
      }
      if (!searchStr) return true;

      const safeString = (val) => {
        if (val === undefined || val === null) return "";
        if (typeof val === 'object') {
          return Object.values(val).map(v => safeString(v)).join(" ");
        }
        return String(val).toLowerCase();
      };

      const itemStr = safeString(item);
      return itemStr.includes(searchStr);
    }).sort((a, b) => {
      if (sortBy === "newest") return new Date(b.createdAt || b.createdDate) - new Date(a.createdAt || a.createdDate);
      if (sortBy === "oldest") return new Date(a.createdAt || a.createdDate) - new Date(b.createdAt || b.createdDate);
      if (sortBy === "name_a_z") {
        const nameA = (a.subCategoryName || a.brandName || a.categoryName || a.vendorName || a.title || a.name || a.itemName || "").toLowerCase();
        const nameB = (b.subCategoryName || b.brandName || b.categoryName || b.vendorName || b.title || b.name || b.itemName || "").toLowerCase();
        return nameA.localeCompare(nameB);
      }
      return 0;
    });
  }, [data, activeTab, search, sortBy]);

  return {
    filteredData,
    totalCount: filteredData.length,
  };
};
